module Client.Zxcvbn

open Fable.Core
open Fable.React 
open Fable.React.Props
open Shared.Zxcvbn

let [<Literal>] RED = "#cd0a0a"
let [<Literal>] YELLOW = "#FF9900"
let [<Literal>] GREEN = "#009933"
let [<Literal>] PROGRESS_BAR_MAX_VALUE = 4

module PasswordScore =
    let toHexColour minStrength = 
        function
        | x when x < SoSo || not (PasswordScore.isStrongEnough minStrength x) -> RED
        | SoSo -> YELLOW
        | _ -> GREEN

    let toProgressBarWidth score =
        let scoreValue = 
            match PasswordScore.toInt score with 
            | x when x < 0 -> 0 
            | x when x > PROGRESS_BAR_MAX_VALUE -> PROGRESS_BAR_MAX_VALUE 
            | x -> x

        let percentage = ((float scoreValue) / (float PROGRESS_BAR_MAX_VALUE)) * 100.
        sprintf "%d%%" (int percentage)

type private ZxcvbnResult = 
    {
        calc_time: int 
        crack_time: float
        crack_time_display: string 
        entropy: float 
        password: string 
        score: int
    }

[<Import("default", from="zxcvbn")>]
let private zxcvbn (password: string) (zxcvbnList: string []): ZxcvbnResult  = jsNative

let scorePassword (zxcvbnList: ZxcvbnList) password = 
    let ret = zxcvbn password (List.toArray zxcvbnList)
    PasswordScore.ofInt ret.score 

let renderPwdStrengthBar minPwdStrength score = 
    let pwdIsStrongEnough = PasswordScore.isStrongEnough minPwdStrength score
    div [
        ClassName (sprintf "password-strength-container ui-widget-content %s" (if not pwdIsStrongEnough then "ui-state-error" else ""))
    ] [
        yield div [
            ClassName "password-strength-progress-container"
        ] [
            div [
                ClassName "password-strength-progress-bar ui-progressbar ui-widget ui-widget-content ui-corner-all"
            ] [
                div [
                    ClassName "ui-progressbar-value ui-widget-header ui-corner-left ui-corner-right"
                    Style [
                        Width (PasswordScore.toProgressBarWidth score)
                        BackgroundColor (PasswordScore.toHexColour minPwdStrength score)
                    ]
                ] [
                    
                ]
            ]

            div [
                ClassName "password-strength-display-text"
                Style [
                    Color (PasswordScore.toHexColour minPwdStrength score)
                ]
            ] [
                str (PasswordScore.toDisplayName score)
            ]
        ]
        if not pwdIsStrongEnough then 
            yield div [] [
                str "The password is not strong enough. It must be 'Good' or better to be accepted. For more information "
                a [
                    Target "_blank"
                    Href "policies/Password Policy - LINKS Carepath.pdf"
                ] [
                    str "Click Here"
                ]
            ]
    ]